import produce from 'immer';
import merge from 'lodash/merge';
import { EAccountActionType, TAccountActions } from '../account/actions';
import { EBlacklistActionType, TBlacklistAction } from '../blacklist/actions';
import { EFavoritesActionType, IFavoritesAction } from '../favorites/actions';
import { ActionsOfType } from '../helpers';
import { initialRootState } from '../initialRootState';
import {
  EPhotoRequestsActionType,
  TPhotoRequestsAction,
} from '../photoRequests/actions';
import {
  EPhotoRevealsActionType,
  TPhotoRevealsActions,
} from '../photoReveals/actions';
import { EThreadsActionType, TThreadsAction } from '../threads/actions';
import { EVisitsActionType, IVisitsAction } from '../visits/actions';
import { EPicturesActionType, IPicturesAction } from './actions';
import { IPicture } from './types';

export interface IPicturesState {
  entries: { [id: string]: IPicture };
}

export const picturesReducer = (
  currentState: IPicturesState = initialRootState.pictures,
  action:
    | IPicturesAction
    | TThreadsAction
    | ActionsOfType<TAccountActions, EAccountActionType.GET_PICTURES_SUCCESS>
    | TBlacklistAction
    | TPhotoRevealsActions
    | TPhotoRequestsAction
    | ActionsOfType<
        IFavoritesAction,
        | EFavoritesActionType.GET_RECEIVED_FAVORITES_SUCCESS
        | EFavoritesActionType.GET_SENT_FAVORITES_SUCCESS
      >
    | ActionsOfType<IVisitsAction, EVisitsActionType.GET_VISITS_SUCCESS>
): IPicturesState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EPicturesActionType.POST_SUCCESS:
      case EPicturesActionType.GET_SUCCESS:
      case EAccountActionType.GET_PICTURES_SUCCESS:
      case EThreadsActionType.GET_SUCCESS:
      case EFavoritesActionType.GET_SENT_FAVORITES_SUCCESS:
      case EBlacklistActionType.GET_SUCCESS:
      case EPhotoRevealsActionType.GET_SUCCESS:
      case EPhotoRequestsActionType.GET_SUCCESS:
        merge(draft.entries, action.payload.entities.pictures);
        break;
      case EVisitsActionType.GET_VISITS_SUCCESS:
      case EFavoritesActionType.GET_RECEIVED_FAVORITES_SUCCESS:
        if (action.payload.isSub) {
          merge(draft.entries, action.payload.entities.pictures);
        } else {
          const pictures = action.payload.entities.pictures;
          // tslint:disable-next-line:prefer-const
          const blurredPictures = {};

          if (pictures) {
            // When user is reg, pictures (from payload) are blurred in visits and received fav.
            // So, the code below to replace formats by blurredFormats
            // to avoid to overwrite blurred pictures by non-blurred pictures (and vice versa)
            // if user switch from home/explore/favSent to visits/favReceived (and vice versa)
            Object.keys(pictures).forEach(memberId => {
              blurredPictures[memberId] = {};
              Object.keys(pictures[memberId]).forEach(pictureKey => {
                blurredPictures[memberId][pictureKey] = {};

                if (pictureKey === 'attributes') {
                  Object.keys(pictures[memberId][pictureKey]).forEach(
                    attributesKey => {
                      if (attributesKey === 'formats') {
                        blurredPictures[memberId][pictureKey].blurredFormats =
                          pictures[memberId][pictureKey].formats;
                      } else {
                        blurredPictures[memberId][pictureKey][attributesKey] =
                          pictures[memberId][pictureKey][attributesKey];
                      }
                    }
                  );
                } else {
                  blurredPictures[memberId][pictureKey] =
                    pictures[memberId][pictureKey];
                }
              });
            });
          }

          merge(draft.entries, blurredPictures);
        }
        break;
    }
  });
